class Client {
    id = null;
    name = '';
    sport_center_name = '';
    oib = '';
    iban = '';
    swift = '';
    address = '';
    city = '';
    postal_code = '';
    country = '';
    invoice_place_of_issue = '';
    invoice_footer_template_hr = '';
    invoice_footer_template_en = '';
    invoice_due_days_person = 0;
    invoice_due_days_company = 0;
    offer_footer_template_hr = '';
    offer_footer_template_en = '';
    offer_valid_days = 0;
    tax_system = false;
    logo = {};
    email_copy = '';
    fiskal = false;
    fiskal_certificate = {};
    fiskal_password = '';
    default_measurement_unit_id = 0;
    invoice_default_customer_id = 0;
    default_payment_method_id = 0;
    default_kpd_code = '';
    pdf_orientation = 'L';
    pdf_customer_offset_x = 0;
    pdf_customer_offset_y = 0;
    pos_left_margin = 2;
    pos_right_margin = 2;
    ppo_template_hr = '';
    ppo_template_en = '';
    e_invoices_token = '';
    e_invoices_middleman = '';
    invoice_document_format_id_1 = 1;
    invoice_document_format_id_2 = 1;
    invoice_document_format_id_3 = 1;
    invoice_document_format_id_4 = 1;
    // Default invoice discount (%) per payment method, keyed by payment method id; saved to payment_methods.
    payment_method_discounts = {};
    ignore_b2b_f1 = false;
    invoice_email_subject = '';
    invoice_email_body = '';
    offer_email_subject = '';
    offer_email_body = '';
    send_membership_expiry_reminders = false;
    membership_expiry_reminder_days = 7;
    membership_expiry_reminder_subject = '';
    membership_expiry_reminder_body = '';
    membership_expiry_reminder_send_offer = false;
    membership_expiry_reminder_send_stripe_link = false;
    send_new_memberships_notifications = false;
    new_membership_notification_subject = '';
    new_membership_notification_body = '';
    working_hours = {};
    reception_working_hours = {};
    fiskal_password_set = false;
    stripe_enabled = false;
    payment_plans_enabled = false;



    constructor(data = {}, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Client;
